// Дерево URL-масок панели. Ключ первого уровня — раздел (плоские неймспейсы),
// значение — набор слагов: 'index' → '/', 'create' → '/create', 'show' → '/:id'.
// Полное имя роута — точечный путь: 'nodes.show' → '/nodes/:id' (см. inc/Routes.js#parseName).
const resource = () => ({
    'index': '/',
    'create': '/create',
    'show': '/:id',
});

const routes = {
    'dashboard': { 'index': '/' },
    'nodes': resource(),
    'devices': { 'index': '/', 'show': '/:id' },
    'device-types': resource(),
    'proxies': resource(),
    'proxy-groups': resource(),
    'users': resource(),
    'roles': resource(),
    'scripts': { 'index': '/' },
    'files': resource(),
    'device-installs': { 'index': '/' },
    'tasks': { 'index': '/' },
    'logs': { 'index': '/' },
    'monitoring': { 'index': '/' },
    'benchmarks': { 'index': '/', 'show': '/:id' },
    'screenshots': { 'index': '/', 'show': '/:id' },
};

export default routes;
